var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicationHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.346 10.5061C12.9931 9.89437 13.8534 9.55911 14.7439 9.57163C15.6343 9.58415 16.4849 9.94346 17.1145 10.5732C17.7442 11.2029 18.1035 12.0534 18.1161 12.9438C18.1286 13.8343 17.7933 14.6946 17.1816 15.3417L13.0604 19.4629C12.4168 20.079 11.5582 20.4197 10.6674 20.4125C9.77651 20.4052 8.92361 20.0508 8.29007 19.4244C7.65655 18.7981 7.29239 17.9492 7.27506 17.0584C7.25773 16.1677 7.58861 15.3053 8.1973 14.6548L12.346 10.5061Z",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.478 12.374L15.3136 17.2096",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38819 4.23535C2.93937 4.23535 2.50894 4.41364 2.19158 4.73101C1.87421 5.04836 1.69592 5.4788 1.69592 5.92762V22.0042C1.69592 22.453 1.87421 22.8834 2.19158 23.2008C2.50894 23.5181 2.93937 23.6964 3.38819 23.6964H22.0031C22.4519 23.6964 22.8823 23.5181 23.1998 23.2008C23.5171 22.8834 23.6954 22.453 23.6954 22.0042V5.92762C23.6954 5.4788 23.5171 5.04836 23.1998 4.73101C22.8823 4.41364 22.4519 4.23535 22.0031 4.23535H18.6186",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77258 1.69629V6.7731",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6185 1.69629V6.7731",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.77258 4.23535H15.2339",
    stroke: "#4F84E8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicationHistory);
export default __webpack_public_path__ + "static/media/medication_history.5a6847e5a8d0df9ffb4b68ebba9904d8.svg";
export { ForwardRef as ReactComponent };